module.exports = ".print-container{page-break-after:always;margin-left:5px}.print-container p{font-size:11px;margin-bottom:5px;line-height:13px}\n"